import { render, staticRenderFns } from "./summaryStatistic.vue?vue&type=template&id=001e4ebc&scoped=true"
import script from "./summaryStatistic.vue?vue&type=script&lang=js"
export * from "./summaryStatistic.vue?vue&type=script&lang=js"
import style0 from "./summaryStatistic.vue?vue&type=style&index=0&id=001e4ebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001e4ebc",
  null
  
)

export default component.exports